import React from 'react';
import cx from 'classnames';
import { 
  FormGroup, InputGroup, FormControl
} from 'react-bootstrap';
import isEqual from 'is-equal';
import styles from './styles.module.scss';

class ProtectedInputField extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      password: '',
      current: false,
      editing: false,
      show: false
    };

    this._handleChange = this._handleChange.bind(this);

    this._toggleShowPassword = this._toggleShowPassword.bind(this);
    this._handleChangePassword = this._handleChangePassword.bind(this);
  }

  componentWillReceiveProps(nextProps){
    if(!isEqual(this.props, nextProps)){
      this.setState({
        current: nextProps.value.current
      })
    }
  }

  _toggleShowPassword(){
    this.setState({
      show: !this.state.show
    }, () => {
      this._triggerChange()
    })
  }

  _handleChangePassword(){
    this.setState({
      current: false
    }, () => {
      this._triggerChange()
    })
  }

  _handleChange(e){
    this.setState({
      password: e.target.value
    }, () => {
      this._triggerChange()
    });
  }

  _triggerChange(){
    if(this.props.onChange){
      this.props.onChange({
        value: this.state.password,
        current: this.state.current
      });
    }
  }

  render(){
    return (
      <div className={styles.passwordField}>
        <FormGroup className={cx(styles.passwordFormGroup, {
          [styles.currentPassword]: this.state.current,
          [styles.plainText]: this.state.show
        })}>
          {!this.state.current &&
            <InputGroup>
              <FormControl 
                type={this.state.show ? 'text' : 'password'}
                placeholder={this.props.placeholder}
                autoComplete={this.props.autoComplete}
                value={this.state.password}
                onChange={this._handleChange}
                className={styles.passwordInput}
                />
              <div>
                <button onClick={this._toggleShowPassword}><i className={cx('paperflite-eye')}></i></button>
              </div>
            </InputGroup>
          }

          {this.state.current &&
            <InputGroup>
              <div className={styles.readOnly}>
                <span>********</span>
              </div>
              <div>
                <button onClick={this._handleChangePassword}>{this.props.actionButton}</button>
              </div>
            </InputGroup>
          }
        </FormGroup>

        {this.props.error && 
          <span className={styles.error}>{this.props.error}</span>
        }
      </div>
    );
  }
}

ProtectedInputField.defaultProps = {
  placeholder: "Enter password",
  actionButton: "CHANGE PASSWORD"
}

export default ProtectedInputField;